export interface FeaturesOverview {
  cardBanner: boolean;
  microMoments: boolean;
  onboarding: boolean;
  summary: boolean;
  status: boolean;
  tracker: boolean;
}

export interface FeaturesEarns {
  amex: boolean;
  offers: boolean;
  partners: boolean;
}

export interface Features {
  welcomeTour: boolean;
  overview: FeaturesOverview;
  quickLinks: boolean;
  benefits: boolean;
  snapshot: boolean;
  upgrades: boolean;
  earns: FeaturesEarns;
  earnsSummary: boolean;
  skyclub: boolean;
  relatedLinks: boolean;
  termsAndConditions: boolean;
  visitSpend: boolean;
}
